



















import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

Vue.filter('formatDate', function (value: string): string | void {
  if (value) {
    return moment(value).format('DD.MM.YYYY')
  }
})

interface ComponentData {
  date: string
  dateRules: Array<(v: string) => string | boolean>
}

interface Payload {
  name: string
  value: string
}

export default Vue.extend({
  name: 'ReportingDatePicker',

  props: {
    name: String,
    label: String,
    defaulValue: String,
    isRequired: Boolean,
    isValid: Boolean
  },

  data (): ComponentData {
    return {
      date: '',
      dateRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ]
    }
  },

  computed: {
    computedDateFormatted (): string | void {
      if (this.date) {
        return this.formatDate(this.date)
      }
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        if (form.validate()) {}
      }
    }
  },

  methods: {

    formatDate (date: string): string {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    onDateChange (): void {
      if (this.date) {
        let payload: Payload = { name: this.name, value: this.date }
        this.$emit('dateChange', payload)
      }
    }
  },

  created () {
    if (this.defaulValue) {
      this.date = this.defaulValue
    }
    if (this.date) {
      let payload: Payload = { name: this.name, value: this.date }
      this.$emit('dateChange', payload)
    }
  }

})
